export const NOTIFICATION = {
  SET: "notification/SET",
};
